<div>
  <app-heading-small-component
    heading1="Stay"
    heading2="Connected"
    heading3="to Your Child's Education"
    description="Access real-time updates, track progress, and engage with the school community."
    imageUrl="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-1.png"
  ></app-heading-small-component>
  <app-cards-wrap
    class="cards-wrap"
    heading1="Why do"
    heading2="Parents Prefer"
    heading3="Inforida"
    heading4="?"
    subheading="See how you can benefit →"
    [array]="benifits"
  ></app-cards-wrap>
  <app-features-card class="features-card"></app-features-card>
</div>
